import styled from "@emotion/styled";
import img1 from "assets/images/open-call-cta-1.jpg";
import img2 from "assets/images/open-call-cta-2.jpg";
import { CtaCentered, H2, Link, Text } from "atoms";

function OpenCallCTA() {
  return (
    <SCtaCentered bg="fg" image1={img1} image2={img2}>
      <H2>Get your Open&nbsp;Call on&nbsp;Hug</H2>
      <Text bold>Looking for artists to exhibit or collaborate&nbsp;with?</Text>
      <Text>
        HUG is home to thousands of artists across 130+ different countries.
        Work with us to leverage the power of community curation to select the
        best artwork for your event, gallery, merchandise, or
        creative&nbsp;brief.
      </Text>
      <SLink
        href="https://go.thehug.xyz/opencallsubmission"
        variant="secondary"
        size="sm"
        arrow="r"
      >
        Partner with Hug
      </SLink>
    </SCtaCentered>
  );
}
const SCtaCentered = styled(CtaCentered)({
  "&&": { margin: "5rem auto 2rem", position: "relative", zIndex: 4 },
  padding: 0,
});

const SLink = styled(Link)(({ theme }) => ({
  color: theme.colors.fg,
  "&:hover, &:focus-visible": {
    borderColor: theme.colors.bg,
  },
}));
export { OpenCallCTA };
